import useTranslate from '@/hooks/use-translate'
import { FC } from 'react'
import {
  Badge,
  exportTypeToBadgeTone,
} from '@/components/Badge'
import type { BadgeSize } from '@/components/Badge/Badge'

interface Props {
  exportType?: string
  exportTypeFullName?: string
  size?: 'small' | 'medium'
  editable?: boolean
  onClick?: () => void
}

const exportTypeBadgeSize = (size: 'small' | 'medium'): BadgeSize =>
  size === 'medium' ? 'md' : 'sm'

const ExportTypeDisplayChip: FC<Props> = ({
  exportType,
  exportTypeFullName,
  size = 'small',
  editable = false,
  onClick,
}) => {
  const { t: tCommon } = useTranslate('common')

  const label = exportType
    ? exportTypeFullName || exportType
    : tCommon('unknown')

  return (
    <Badge
      tone={exportTypeToBadgeTone(exportType)}
      size={exportTypeBadgeSize(size)}
      editable={editable}
      onClick={onClick}
      data-testid="export-type-display-chip"
      sx={{ textTransform: 'capitalize' }}
    >
      {label}
    </Badge>
  )
}

export default ExportTypeDisplayChip
